class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.listeners?.abort();
    this.listeners = new AbortController();
    const options = { signal: this.listeners.signal };
    this.setAttribute('aria-modal', 'true');
    this.setAttribute('aria-label', 'Carrito de compras');
    this.setAttribute('tabindex', '-1');
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-cart-drawer-btn]');
      if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      this.openDrawer(event, trigger);
    }, options);
    this.addEventListener('click', (event) => {
      const close = event.target.closest('[data-close-drawer], [cart-drawer-close]');
      if (close && this.contains(close)) {
        this.closeDrawer(event);
        return;
      }
      const modalClose = event.target.closest('.cart-dialog-close');
      if (modalClose) {
        event.preventDefault();
        this.closeDialog(modalClose.closest('cart-dialog'));
        return;
      }
      const trigger = event.target.closest('.cart-modal-button');
      if (!trigger) return;
      const dialog = Array.from(this.querySelectorAll('cart-dialog')).find((item) => item.id === trigger.dataset.modal);
      if (!dialog) return;
      event.preventDefault();
      this.dialogOpener = trigger;
      dialog.style.display = 'block';
      dialog.classList.add('active');
      trapFocusElements(dialog);
    }, options);
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || (!this.classList.contains('open') && !this.opening)) return;
      const dialog = this.querySelector('cart-dialog.active');
      if (dialog) {
        event.preventDefault();
        this.closeDialog(dialog);
      } else {
        this.closeDrawer(event);
      }
    }, options);
  }

  disconnectedCallback() {
    this.listeners?.abort();
    this.openController?.abort();
    clearTimeout(this.focusTimer);
    if (this.classList.contains('open')) {
      removeTrapFocus();
      if (!document.querySelector('.drawer.open')) document.body.classList.remove('no-scroll');
    }
  }

  dialogEvents() {}

  closeDialog(dialog) {
    if (!dialog) return;
    dialog.classList.remove('active');
    dialog.style.display = 'none';
    trapFocusElements(this);
    this.dialogOpener?.focus();
    this.dialogOpener = null;
  }

  async openDrawer(event, opener) {
    event?.preventDefault();
    this.opener?.removeAttribute('aria-busy');
    this.opener = opener || event?.target?.closest('button, a, [tabindex]') || document.activeElement;
    const requestOpener = this.opener;
    this.openController?.abort();
    this.opening = true;
    this.openController = new AbortController();
    const controller = this.openController;
    this.opener?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(this.dataset.url || `${routes.cart_url}?section_id=cart-drawer`, { signal: controller.signal });
      if (!response.ok) throw new Error('Cart drawer unavailable');
      const html = await response.text();
      if (controller.signal.aborted) return false;
      if (!this.renderContents({ sections: { 'cart-drawer': html } })) throw new Error('Cart drawer content missing');
      this.show(this.opener);
      return true;
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(routes.cart_url);
      return false;
    } finally {
      if (controller === this.openController) {
        this.opening = false;
        requestOpener?.removeAttribute('aria-busy');
      }
    }
  }

  show(opener) {
    this.opener = opener || this.opener || document.activeElement;
    focusElement = this.opener;
    this.classList.add('open');
    document.body.classList.add('no-scroll');
    document.querySelectorAll('[data-cart-drawer-btn]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
    clearTimeout(this.focusTimer);
    this.focusTimer = setTimeout(() => {
      if (this.isConnected && this.classList.contains('open')) trapFocusElements(this);
    }, 0);
  }

  restoreFocusAfterUpdate(name) {
    if (!this.classList.contains('open')) return;
    trapFocusElements(this);
    const input = name && Array.from(this.querySelectorAll('input[name]')).find((element) => element.name === name && !element.disabled);
    input?.focus();
  }

  renderContents(parsedState) {
    const html = parsedState?.sections?.['cart-drawer'];
    if (typeof html !== 'string') return false;
    const source = new DOMParser().parseFromString(html, 'text/html');
    const card = source.querySelector('.drawer-inner-card');
    const body = source.querySelector('#cart-drawer-body');
    const target = this.querySelector('.drawer-inner-card');
    if (!card || !body || !target) return false;
    target.innerHTML = card.innerHTML;
    const count = Number(body.dataset.cartCount) || 0;
    document.querySelectorAll('[data-item-count]').forEach((counter) => {
      counter.textContent = count > 99 ? '99+' : String(count);
      counter.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('[data-cart-drawer-btn]').forEach((trigger) => trigger.setAttribute('aria-label', `Carrito (${count})`));
    const total = Number(body.dataset.cartPrice);
    if (Number.isFinite(total)) shippingBarProgress(total);
    return true;
  }

  getSectionsToRender() {
    return [{ id: 'cart-drawer', section: 'cart-drawer', selector: '.drawer-inner-card' }];
  }

  getSectionInnerHTML(html, selector = '.drawer-inner-card') {
    if (typeof html !== 'string') return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML ?? null;
  }

  closeDrawer(event) {
    if (!this.classList.contains('open') && !this.opening) return;
    event?.preventDefault();
    this.openController?.abort();
    this.opening = false;
    this.opener?.removeAttribute('aria-busy');
    clearTimeout(this.focusTimer);
    this.classList.remove('open');
    this.querySelectorAll('cart-dialog.active').forEach((dialog) => {
      dialog.classList.remove('active');
      dialog.style.display = 'none';
    });
    document.querySelectorAll('[data-cart-drawer-btn]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    if (!document.querySelector('.drawer.open')) document.body.classList.remove('no-scroll');
    removeTrapFocus();
    if (this.opener?.isConnected) this.opener.focus();
    focusElement = '';
    this.opener = null;
  }
}
customElements.define('cart-drawer', CartDrawer);
